import { useState, useEffect } from "react";
import { useWallet } from "@/contexts/WalletContext";

export function useOnboarding() {
  const { connected, publicKey } = useWallet();
  const [shouldShowOnboarding, setShouldShowOnboarding] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    // Only check once wallet is connected
    if (!connected || !publicKey) {
      setHasChecked(true);
      setShouldShowOnboarding(false);
      return;
    }

    // Check if user has completed onboarding
    const onboardingComplete = localStorage.getItem("onboarding_complete");
    const onboardingWallet = localStorage.getItem("onboarding_wallet");

    // Show onboarding if not completed or if different wallet
    if (!onboardingComplete || onboardingWallet !== publicKey) {
      setShouldShowOnboarding(true);
    } else {
      setShouldShowOnboarding(false);
    }
    
    setHasChecked(true);
  }, [connected, publicKey]);

  const completeOnboarding = () => {
    if (publicKey) {
      localStorage.setItem("onboarding_complete", "true");
      localStorage.setItem("onboarding_wallet", publicKey);
    }
    setShouldShowOnboarding(false);
  };

  const resetOnboarding = () => {
    localStorage.removeItem("onboarding_complete");
    localStorage.removeItem("onboarding_wallet");
    localStorage.removeItem("user_type");
    setShouldShowOnboarding(true);
  };

  return {
    shouldShowOnboarding,
    hasChecked,
    completeOnboarding,
    resetOnboarding,
  };
}
